module.exports = __webpack_public_path__ + "img/bronze.9a9a511e.png";